var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-responsive-sm",attrs:{"id":"TabContract"}},[_c('section',[_c('vue-good-table',{ref:"listAssetTable",attrs:{"title":"Asset","columns":_vm.columns,"rows":_vm.rows,"max-height":"600px","totalRows":_vm.totalRecords,"pagination-options":{
              enabled: true,
              position:'top',
              mode: 'records',
              perPage: 50,
              perPageDropdown:[50,100],
              dropdownAllowAll: false,
          },"search-options":{
              enabled: false,
              placeholder: 'Search Asset',
          },"select-options":{
              enabled: false,
              selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
              selectionInfoClass: 'custom-class',
              selectionText: 'rows selected',
              clearSelectionText: 'clear',
          },"sort-options":{
              enabled: true,
          }},scopedSlots:_vm._u([_vm._l((_vm.rows),function(row,key){return {key:"table-row",fn:function(props){return [_c('div',{key:key},[(props.column.field == 'vehicle_name')?[_c('router-link',{staticClass:"color-blue",attrs:{"target":"_blank","title":"View Asset","to":{name: 'ContractAssetView',params:{id:props.row.id}}}},[_vm._v("\n                        "+_vm._s(props.row.vehicle_name)+"\n                    ")])]:(props.column.field == 'section')?[_c('span',[_vm._v(_vm._s(props.row.section))])]:[_vm._v("\n                      "+_vm._s(props.formattedRow[props.column.field])+"\n                  ")]],2)]}}})],null,true)},[_c('div',{attrs:{"slot":"emptystate"},slot:"emptystate"},[_vm._v("\n              No Data Found.\n          ")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c001bfc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContractAssetTabView.vue
// module id = null
// module chunks = 